// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2334":"95b75b75","2804":"6c1552bc","6631":"045e6125","6642":"b2d0f933","7608":"e7a1d701","8181":"45f754b1"}[chunkId] + ".chunk.css";
};